import React, { useState, useEffect } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

function Sliders_2_hotels({ section }) {
  const [isScrolled, setIsScrolled] = useState(false);

  const settings = {
    dots: false,
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    centerMode: false,
    centerPadding: "0px",
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2, // Show 2 slides on medium screens
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2, // Show 2 slides on small screens
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 320,
        settings: {
          slidesToShow: 1, // Show 1 slide on very small screens
          slidesToScroll: 1,
        },
      },
    ],
  };


  const handleScroll = () => {
    const scrollTop = window.scrollY || document.documentElement.scrollTop;
    if (scrollTop > 50) {
      setIsScrolled(true);
    } else {
      setIsScrolled(false);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <div>
      <div className="container offers pb-5 pt-3">
        <div className="popular-state pb-0 pt-0 mb-5">
          <div className="container">
            <div className="title">
              <h3 className="pb-0">{section?.title_highlight ? <span>{section.title_highlight} </span> : <span>Why Book Hotels </span>} {section?.title || 'With mangoloops?'}</h3>
            </div>
          </div>
        </div>
        <div className={`customer-logos slider slides-wrapper ${isScrolled ? "slide" : ""}`}>
          <Slider {...settings}>
            {(section?.Items?.length ? section.Items : [
              { title: 'Reason 1', image_url: 'assets/img/hotels/why-us/1.webp' },
              { title: 'Reason 2', image_url: 'assets/img/hotels/why-us/2.webp' },
              { title: 'Reason 3', image_url: 'assets/img/hotels/why-us/3.webp' },
              { title: 'Reason 4', image_url: 'assets/img/hotels/why-us/4.webp' },
              { title: 'Reason 5', image_url: 'assets/img/hotels/why-us/5.webp' },
            ]).map((item, index) => (
              <div key={index}>
                <img className="why-choose-hotel-img" src={item.image_url} alt={item.title || `Reason ${index + 1}`} />
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </div>
  );
}

export default Sliders_2_hotels;
